import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function AnimatedText({
  children,
  as: Tag = 'h2',
  className = '',
  splitBy = 'chars', // 'chars' | 'words' | 'lines'
  stagger = 0.03,
  duration = 0.8,
  delay = 0,
  triggerStart = 'top 80%',
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const text = el.textContent;
    el.innerHTML = '';

    let elements;
    if (splitBy === 'chars') {
      elements = text.split('').map((char) => {
        const span = document.createElement('span');
        span.style.display = 'inline-block';
        span.style.opacity = '0';
        span.style.transform = 'translateY(40px)';
        span.textContent = char === ' ' ? '\u00A0' : char;
        el.appendChild(span);
        return span;
      });
    } else {
      elements = text.split(' ').map((word, i) => {
        const span = document.createElement('span');
        span.style.display = 'inline-block';
        span.style.opacity = '0';
        span.style.transform = 'translateY(30px)';
        span.textContent = word;
        el.appendChild(span);
        if (i < text.split(' ').length - 1) {
          const space = document.createElement('span');
          space.innerHTML = '&nbsp;';
          el.appendChild(space);
        }
        return span;
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: triggerStart,
        toggleActions: 'play none none none',
      },
    });

    tl.to(elements, {
      opacity: 1,
      y: 0,
      duration,
      stagger,
      delay,
      ease: 'power3.out',
    });

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach((st) => {
        if (st.trigger === el) st.kill();
      });
    };
  }, [children, splitBy, stagger, duration, delay, triggerStart]);

  return (
    <Tag ref={containerRef} className={className}>
      {children}
    </Tag>
  );
}
